import { RouteComponentProps } from 'react-router';
import { getIDFromUrl } from '@rossum/api-client';
import { PageLayout } from '@rossum/components/page-layout/PageLayout';
import { CircularProgress, Stack } from '@rossum/ui/material';
import { useGetInbox } from '../../../../features/document-upload/hooks/useGetInbox';
import { EmailsHeader } from '../../../../features/queue-settings/headers/EmailsHeader';
import { useQueueWithWorkspace } from '../../../../features/queues/hooks/useQueueWithWorkspace';
import QueueEmailsContainer from './QueueEmailsContainer';

type QueueEmailsProps = RouteComponentProps<{ queueId: string }> & {
  workspaceName: string;
};

export const QueueEmails = ({
  match: {
    url,
    params: { queueId },
  },
  workspaceName,
}: QueueEmailsProps) => {
  const { queue, workspaceIsLoading } = useQueueWithWorkspace({
    queueId: Number(queueId),
  });

  const { data: inbox, isFetching: inboxIsLoading } = useGetInbox(
    queue && queue.inbox ? getIDFromUrl(queue?.inbox) : 0
  );

  if (!queue) return null;

  return (
    <PageLayout
      renderHeader={params => (
        <EmailsHeader
          parentPath={url}
          queue={queue}
          workspaceName={workspaceName}
          scrollableDivRef={params.scrollableDivRef}
        />
      )}
    >
      {workspaceIsLoading || inboxIsLoading ? (
        <Stack
          sx={{
            width: 1,
            p: 8,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </Stack>
      ) : (
        <QueueEmailsContainer inbox={inbox} selectedQueue={queue} />
      )}
    </PageLayout>
  );
};
